/// <reference path="../../app.definition.ts" />

import angular from "angular";
import { CachedItem } from "./_cachedItem";
import { Subject } from "./subject";
import { User } from "./user";

export class CachedTeam extends CachedItem {
    subjectId: number;
    isFrozen: boolean;
    memberIds: Array<{ id: number, former: boolean }>;

    deserialize(input: Subject): CachedTeam {
        !!input.subjectId && (this.subjectId = input.subjectId);
        !!input.isFrozen && (this.isFrozen = input.isFrozen);

        if (!!input.teamMembers && input.teamMembers.length > 0) {
            this.memberIds = new Array();
            angular.forEach(input.teamMembers, (member: User) => {
                this.memberIds.push({ 'id': member.id, 'former': member.isFormerTeamMember });
            });
        }

        super.deserialize(input);
        return this;
    }

    constructor() {
        super();
    }
}
